import { render, staticRenderFns } from "./current.vue?vue&type=template&id=2eb6251b&scoped=true"
import script from "./current.vue?vue&type=script&lang=ts"
export * from "./current.vue?vue&type=script&lang=ts"
import style0 from "./current.vue?vue&type=style&index=0&id=2eb6251b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb6251b",
  null
  
)

export default component.exports